var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.haveIncidents())?_c('span',{class:_vm.colorClass},[_vm._v(" ( "),_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.total))]),_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}}),_vm._v(" ) ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }